const STORAGE_PREFIX = "mogu.featureNews.dismissed.";

const getStorageKey = (userId) => `${STORAGE_PREFIX}${userId}`;

export const isFeatureNewsEnabled = () =>
  String(process.env.REACT_APP_FEATURE_NEWS_ENABLED ?? "true").toLowerCase() !== "false";

export const getDismissedNewsIds = (userId) => {
  if (!userId) {
    return [];
  }
  try {
    const parsed = JSON.parse(localStorage.getItem(getStorageKey(userId)) || "[]");
    return Array.isArray(parsed)
      ? parsed.filter((id) => typeof id === "string")
      : [];
  } catch {
    return [];
  }
};

export const getFeatureNewsDismissKey = (item) => {
  if (!item?.id) {
    return "";
  }
  return `${item.id}:${item.revision ?? 1}`;
};

export const getUnreadFeatureNews = (userId, allNews = []) => {
  const dismissed = new Set(getDismissedNewsIds(userId));
  return (Array.isArray(allNews) ? allNews : []).filter((item) => {
    if (item?.isActive === false) {
      return false;
    }
    const dismissKey = getFeatureNewsDismissKey(item);
    return Boolean(dismissKey) && !dismissed.has(dismissKey);
  });
};

export const dismissFeatureNews = (userId, newsIds) => {
  if (!userId || !newsIds?.length) {
    return;
  }
  const next = new Set(getDismissedNewsIds(userId));
  newsIds.forEach((id) => {
    if (id) {
      next.add(id);
    }
  });
  localStorage.setItem(getStorageKey(userId), JSON.stringify([...next]));
};
